import {
  GET_AVALARA_INVOICE_REQUEST,
  GET_AVALARA_INVOICE_SUCCESS,
  GET_AVALARA_INVOICE_ERROR,
} from "./types.js";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getAvalaraInvoice = (token, data, report) => (dispatch) => {
  dispatch({ type: GET_AVALARA_INVOICE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/avalaraInvoice`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(data.from_date).format("MM-DD-YYYY"),
      to_date: moment(data.to_date).format("MM-DD-YYYY"),
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_AVALARA_INVOICE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_AVALARA_INVOICE_ERROR,
        payload: [],
      });
    });
};

